import createPersistedState from 'vuex-persistedstate'

export default createPersistedState({
  key: 'gyst',
  paths: ['user', 'shits', 'mits', 'bigRocks', 'filters', 'settings'],
  rehydrated: s => {
    let projects = []
    let contexts = []
    let mentions = []

    s.getters.shits.forEach(shit => {
      projects = projects.concat(shit.projects)
      contexts = contexts.concat(shit.contexts)
      mentions = mentions.concat(shit.mentions || []) // we have shits that have no mentions
    })

    // remove duplicates
    projects = [...new Set(projects)]
    contexts = [...new Set(contexts)]
    mentions = [...new Set(mentions)]

    s.commit('hydrateProjects', projects)
    s.commit('hydrateContexts', contexts)
    s.commit('hydrateMentions', mentions)
    s.commit('setLoaded')
  }
})
